import type { AreaCatalog } from '../area';
import type { palette as en } from '../en/palette';

export const palette = {
  'palette.command.goTo': '{page} öffnen',
  'palette.command.newItem': 'Neue Aufgabe',
  'palette.command.newLens': 'Neue Ansicht',
  'palette.command.newView': 'Neues Board',
  'palette.command.themeLight': 'Erscheinungsbild: Hell',
  'palette.command.themeDark': 'Erscheinungsbild: Dunkel',
  'palette.command.themeSystem': 'Erscheinungsbild: Automatisch',
  'palette.kind.page': 'Seite',
  'palette.kind.board': 'Board',
  'palette.kind.view': 'Landkartenansicht',
  'palette.kind.lens': 'Ansicht',
  'palette.kind.group': 'Gruppe',
  'palette.kind.flow': 'Ablauf',
  'palette.kind.plan': 'Plan',
  'palette.kind.ceremony': 'Besprechung',
  'palette.kind.person': 'Person',
  'palette.kind.command': 'Befehl',
  'palette.kind.narrowBy': 'eingrenzen nach…',
  'palette.kind.filter': 'Filter',
  'palette.kind.item': 'Aufgabe',
  'palette.panel.command': 'Befehl ausführen',
  'palette.panel.open': 'Springen zu',
  'palette.input.command': 'Befehl eingeben',
  'palette.input.open':
    'Aufgaben suchen oder zu einer Ansicht oder einem Board springen (> für Befehle)',
  'palette.input.commandPlaceholder': 'Befehl ausführen…',
  'palette.input.openPlaceholder': 'Suchen…',
  'palette.empty.command': 'Kein passender Befehl.',
  'palette.empty.noMatches': 'Keine Treffer.',
  'palette.empty.hint': 'Tippe, um Aufgaben und Orte zu suchen.',
  'palette.row.seeAll': 'Alle Ergebnisse anzeigen',
  'palette.itemSearch.cancel': 'Abbrechen',
  'palette.itemSearch.placeholder': 'Aufgaben durchsuchen…',
  'palette.itemSearch.results': 'Passende Aufgaben',
  'palette.keywords.goTo': 'öffnen springen gehe zu',
  'palette.keywords.newItem': 'erstellen aufgabe hinzufügen neu',
  'palette.keywords.newLens': 'erstellen ansicht filter hinzufügen neu',
  'palette.keywords.newView': 'erstellen board kanban liste checkliste hinzufügen neu',
  'palette.keywords.themeLight': 'erscheinungsbild farben hell',
  'palette.keywords.themeDark': 'erscheinungsbild farben dunkel nacht',
  'palette.keywords.themeSystem': 'erscheinungsbild farben automatisch system',
} as const satisfies AreaCatalog<typeof en>;
